import { render, staticRenderFns } from "./parkingArea.vue?vue&type=template&id=4f89e30a&scoped=true"
import script from "./parkingArea.vue?vue&type=script&lang=js"
export * from "./parkingArea.vue?vue&type=script&lang=js"
import style0 from "./parkingArea.vue?vue&type=style&index=0&id=4f89e30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f89e30a",
  null
  
)

export default component.exports